/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Validation_Name_Or_UrlInputs */

const en_profile_validation_name_or_url = /** @type {(inputs: Profile_Validation_Name_Or_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a display name and/or avatar URL.`)
};

const pt_br2_profile_validation_name_or_url = /** @type {(inputs: Profile_Validation_Name_Or_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um nome de exibição e/ou URL do avatar.`)
};

/**
* | output |
* | --- |
* | "Enter a display name and/or avatar URL." |
*
* @param {Profile_Validation_Name_Or_UrlInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_validation_name_or_url = /** @type {((inputs?: Profile_Validation_Name_Or_UrlInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Validation_Name_Or_UrlInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_validation_name_or_url(inputs)
	return pt_br2_profile_validation_name_or_url(inputs)
});